export const DISPONIBILIDAD_CONSULTAR = 'DISPONIBILIDAD_CONSULTAR';
export const DISPONIBILIDAD_SET_DISPONIBILIDAD = 'DISPONIBILIDAD_SET_DISPONIBILIDAD';
